module.exports = function getFunctionName(f) {
  return f.displayName || f.name || '<function' + f.length + '>';
};


//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/tcomb/lib/getFunctionName.js
// module id = 119
// module chunks = 0